import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Button } from "@mui/material";
import Toast from "../../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../../hooks/digitalMarketing/useSnackbar";
import { carepackagesInput } from "../Utils/CarePackagesInputs";
import {
  useCreateCarePackageMutation,
  useUpdateCarePackageMutation,
  useGetProcedureTitlesQuery,
} from "../../../../Service/CarePackages";

const TestPackages = (props) => {
  const { updateData, setShow, refetch } = props;

  const [formData, setFormData] = useState({
    packageName: updateData?.packageName || "",
    discount: updateData?.discount || "",
    price: updateData?.price || "",
    validityPeriod: updateData?.validityPeriod || "",
    services: updateData?.services || "",
    termsAndCondition: updateData?.termsAndCondition || "",
  });

  const { open, message, openSnackBar, type } = useSnackbar();
  const [submit, setSubmit] = useState(false);
  
  const [addCarePackage, { isLoading: addLoading }] =
    useCreateCarePackageMutation();
  const [updateCarePackage, { isLoading: updateLoading }] =
    useUpdateCarePackageMutation();

  const [selectedServices, setSelectedServices] = useState([]);

  const { data: procedureData, isLoading: proceduresLoading } =
    useGetProcedureTitlesQuery();

  const procedureOptions =
    procedureData?.data?.map((item) => ({
      value: item.procedureTitle,
      label: item.procedureTitle,
    })) || [];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    
  };

 

  const handleServiceChange = (selectedOptions) => {
    setSelectedServices(selectedOptions);
    const updatedServices = selectedOptions.map((opt, index) => ({
      id: index + 1,
      procedureName: opt.value,
    }));
    setFormData({ ...formData, services: updatedServices });
  };

  const handleSubmit = async () => {
    setSubmit(true);
    const missingFields = Object.entries(formData).filter(
      ([key, value]) => !value && key !== "servicesNames"
    );
    if (missingFields.length > 0) {
      openSnackBar("Please fill all required fields.", "error");
      setSubmit(false)
      return;
    }

    try {
      if (updateData?.id) {
        await updateCarePackage({
          id: updateData.id,
          ...formData,
        }).unwrap();
        openSnackBar("Updated successfully", "success");
      } else {
        await addCarePackage({
          ...formData,
          activeStatus: "1",
        }).unwrap();
        openSnackBar("Created successfully", "success");
      }

      refetch();
     
      setTimeout(() => setShow(false), 350);
    } catch (error) {
      console.error("Error during submission:", error);
      openSnackBar("An error occurred. Please try again.", "error");
    } finally {
      setSubmit(false);
    }
  };

  useEffect(() => {
    if (updateData) {
      setFormData({
        packageName: updateData.packageName || "",
        discount: updateData.discount || "",
        price: updateData.price || "",
        validityPeriod: updateData.validityPeriod || "",
        services: updateData.services || "",
        termsAndCondition: updateData?.termsAndCondition || "",
      });

      const selectedLanguages =
        updateData.services
          ?.split(",")
          .map((id) => {
            const item = procedureData?.find(
              (lang) => lang.id === parseInt(id)
            );
            return item
              ? { value: item.procedureTitle, label: item.procedureTitle }
              : null;
          })
          .filter(Boolean) || [];

      setSelectedServices(selectedLanguages);
    }
  }, [updateData, procedureData]);


  return (
    <div>
      <Toast open={open} type={type} message={message} />
      <div className="mt-3">
        <span className="f-18 fw-700">
          {updateData?.id ? "Edit Care Package" : "Add Care Package"}
        </span>
      </div>

      {carepackagesInput.map((input, index) => (
        <div className="input-custom mt-2" key={index}>
          <input.tag
            label={input.label}
            name={input.name}
            {...formData}
            handleChange={handleInputChange}
            validation={input.validation}
            submit={submit}
          />
        </div>
      ))}
      <div className="d-flex justify-content-between mt-2 ">
        <div>
          <label className="det-label">Validity Period</label>
        </div>
        <div className="input-custom">
        <Select
          options={[
            { label: "1 Year", value: "1 year" },
            { label: "6 Month", value: "6 month" },
            { label: "30 Days", value: "30 day" },
          ]}
          value={
            formData.validityPeriod
              ? {
                  value: formData.validityPeriod,
                  label: formData.validityPeriod,
                }
              : null
          }
          onChange={(selectedOption) =>
            setFormData((prev) => ({
              ...prev,
              validityPeriod: selectedOption.value,
            }))
          }
        />
        </div>
      </div>
      <div className="d-flex justify-content-between mt-2">
        <div>
          <label className="det-label">Included Services</label>
        </div>
        <div className="input-custom">
          {proceduresLoading ? (
            <p>Loading services...</p>
          ) : (
            <Select
              isMulti
              options={procedureOptions}
              value={selectedServices}
              onChange={handleServiceChange}
            />
          )}
        </div>
      </div>

      <div className="d-flex justify-content-center mt-4">
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={addLoading || updateLoading || submit}
        >
          {updateData?.id ? "Update Care Package" : "Add Care Package"}
        </Button>
      </div>
    </div>
  );
};

export default TestPackages;
